/* eslint-disable import/group-exports, eslint-comments/disable-enable-pair */
import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleNewestSuperOffer } from 'src/redux/actions/toggle-offer';
import { setSuperOffersImpressionsSent } from 'src/redux/actions/impressions';
import { collectClick, collectImpressions } from 'src/utils/analytics/analyticsEvents';


const mapStateToProperties = ({ superOffers: { list }, links, impressions }) => ({
  superOffers: list,
  hasSuperOffersImpressionBeenSent: impressions.superOffersImpressionSent,
  links
});

const list = 'super_oferty_sg';

export function sendAnalyticsEvent(event, offer) {
  collectClick(event, offer, list);
}

export const useSuperOffersContainer = () => {
  const { superOffers, hasSuperOffersImpressionBeenSent, links } = useSelector(mapStateToProperties);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasSuperOffersImpressionBeenSent) {
      collectImpressions(superOffers, list);
      dispatch(setSuperOffersImpressionsSent(true));
    }
  }, [
    dispatch,
    hasSuperOffersImpressionBeenSent,
    superOffers
  ]);

  const toggleFavouriteOffer = useCallback((offerId, isFavourite) => {
    dispatch(toggleNewestSuperOffer({ offerId, isFavourite, links }));
  }, [links, dispatch]);

  return {
    toggleFavouriteOffer,
    superOffers,
    links
  };
};
